import React, { createContext, useContext, useEffect } from "react" 
import { Outlet, useParams } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { ConditionalProvider, ConditionalWorkingArea, Welcome } from "lib/units/conditional"
// import { Client } from "." 

export default function ConditionalsPage({ className="" }:{ className?:string }){

  const { ctid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  
  const { data:_Conditionals } = queryTools.resource.parseQueryForApi("conditional.findAll", {})
  const { data:_Conditional } = queryTools.resource.parseQueryForApi("conditional.findById", { _id: ctid }, { enabled: !!ctid })
  const saveFn = queryTools.resource.save(["conditional.all"])

  const [ currentConditional, setCurrentConditional ] = React.useState<any>()
  
  const saveConditional = () => {
    saveFn.mutate({ resource: "conditional", data: _Conditional._id } )
  }

  return (
    <div className={cn("w-full pt-6", className)}>
      <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="conditionals manager">
        <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={saveConditional} />
      </UnitTitleBlock>

      <div className="w-full flex items-stretch h-[40rem] gap-4">
        
        <div className="w-3/12 flex justify-start overflow-auto scrollbar border border-solid border-slate-700">
          <CollectionLoader 
            title="Conditionals Loader"
            collection={_Conditionals || []} 
            labelProp="name" 
            showDescriptions={true}
            draggable={true} 
            className=""
          />
        </div>

        <div className="w-9/12">
          <ConditionalProvider usage="conditional" className={cn("h-full flex flex-col grow border border-solid border-slate-700 relative")}>
            <ConditionalWorkingArea />
          </ConditionalProvider>
        </div>

      </div>
  
    </div>
  )
}